import { useEffect, useState } from 'react';

const STORAGE_KEY = 'dashboard_nav_size';

export const MIN_WIDTH = 200;
export const MAX_WIDTH = 400;

const defaultWidth = (compact) => (compact ? 220 : 240);
// Só ícones: o botão (40px) mais o respiro do ListItem.
const collapsedWidth = (compact) => (compact ? 56 : 64);

const clamp = (width) => Math.round(Math.min(MAX_WIDTH, Math.max(MIN_WIDTH, width)));

// Tamanho é conveniência do navegador: sem storage, volta ao padrão.
function readSize() {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
    return {
      collapsed: stored?.collapsed === true,
      // null = largura padrão, que acompanha o modo compacto.
      width: Number.isFinite(stored?.width) ? clamp(stored.width) : null,
    };
  } catch {
    return { collapsed: false, width: null };
  }
}

function writeSize(size) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(size));
  } catch {
    // Storage bloqueado: o tamanho só não sobrevive ao reload.
  }
}

/**
 * Largura do drawer: recolhido (só ícones) ou expandido, na largura que o
 * usuário arrastou ou na padrão. `expandedWidth` é a largura de referência
 * do arraste, mesmo com o drawer recolhido.
 */
export default function useDrawerSize(compact) {
  const [size, setSize] = useState(readSize);

  useEffect(() => {
    writeSize(size);
  }, [size]);

  const expandedWidth = size.width ?? defaultWidth(compact);

  return {
    collapsed: size.collapsed,
    width: size.collapsed ? collapsedWidth(compact) : expandedWidth,
    expandedWidth,
    toggleCollapsed: () => setSize((s) => ({ ...s, collapsed: !s.collapsed })),
    resize: (width) => setSize((s) => ({ ...s, width: clamp(width) })),
    resetWidth: () => setSize((s) => ({ ...s, width: null })),
  };
}
